<template>
  <div>
    <Header />
    <div class="main-content text-left text-normal privacy-content">
        <h1 class="text-title font-bold">PRIVACY POLICY</h1>
        <div class="text-content" v-html="pageContent"></div>
    </div>
    <Footer />
    <SocialLinks />
  </div>
</template>

<script>
  import Header from '../components/common/Header'
  import Footer from '../components/common/Footer'
  import SocialLinks from '../components/common/SocialLinks'

  export default {
    name: 'Privacy',
    metaInfo: {
      title: 'Privacy Policy',
    },
    computed: {
        privacyData() {
            return this.$store.state.privacyContent
        },
        pageContent() {
            return this.privacyData.content && this.privacyData.content.rendered
        }
    },
    components: {
      Header,
      Footer,
      SocialLinks
    },
  }
</script>

<style>
.privacy-content {
    padding-left: 8%;
    padding-right: 8%;
}
.text-title {
    margin-bottom: 15px
}
@media (min-width: 992px) {
    .text-title {
        margin-bottom: 30px
    }
    .privacy-content {
        padding-left: 8%;
        padding-right: 8%;
    }
}
</style>